import type { TranslationMessages } from '../types';

export const ra: TranslationMessages = {
  action: {
    choose_language: 'Choose language',
    skip: 'Skip',
    actions: 'Actions',
    create: 'Create',
    clear: 'Clear',
    apply: 'Apply',
    help: 'Help',
    support: 'Support',
    open: 'Open',
    previous: 'Previous',
    next: 'Next',
    finish: 'Finish',
    close: 'Close',
    cancel: 'Cancel',
    load_more: 'Load more',
    confirm: 'Confirm',
    edit: 'Edit',
    show: 'Show',
    completed: 'Completed',
    available: 'Available',
    review: 'Review',
    start: 'Start',
    filter: 'Filter',
    apply_filters: 'Apply Filters',
    clear_filters: 'Clear Filters',
    back_to_list: 'Back to List',
    search_placeholder: 'Search...',
    loading: 'Loading...',
    error_loading: 'Error loading data',
    failed_to_load: 'Failed to load data. Please try again.',
    failed_to_save: 'Failed to save. Please try again.',
    failed_to_delete: 'Failed to delete. Please try again.',
    failed_to_create: 'Failed to create. Please try again.',
    failed_to_update: 'Failed to update. Please try again.',
    toggle_theme: 'Toggle theme',
    clear_all_filters: 'Clear all filters',
    table_view: 'Table View',
    card_view: 'Card View',
    select_category: 'Select category',
    select_status: 'Select status',
    minimum_amount: 'Minimum total amount',
  },
  auth: {
    forgot_password: 'Forgot password?',
    remember_password: 'Remember password',
    reset_password: 'Reset password',
    email: 'Email',
    username_email_password_required:
      'Username/email and password are required',
    invalid_credentials: 'Invalid username/email or password',
    invalid_username_email: 'Invalid username/email',
    invalid_password: 'Invalid password',
    invalid_username: 'Invalid username',
    invalid_email: 'Invalid email',
    invalid_username_or_email: 'Invalid username/email',
    close_window: 'Close',
    set_new_password: 'Update Password',
    username_or_email: 'Username/email',
    username_or_email_placeholder: 'Enter username or email',
    password: 'Password',
    password_placeholder: 'Enter your password',
    sign_in: 'Sign In',
    welcome_back: 'Welcome back! Please sign in to your account.',
    or: 'or',
    sign_in_with_passkey: 'Sign in with Passkey',
    passkey_error: 'Failed to sign in with passkey',
    passkey_not_supported: 'Passkey is not supported on this device',
    no_passkeys:
      'No passkeys registered. Please sign in with username/password first, then register a passkey in your profile settings.',
    passkey_register: 'Register Passkey',
    passkey_register_success: 'Passkey registered successfully',
    passkey_register_error: 'Failed to register passkey',
    passkey_not_registered:
      'No passkeys registered yet. Please log in with your username/password first, then register a passkey in your profile settings.',
    register_passkey: 'Register Passkey',
    register_passkey_description:
      'Would you like to set up a passkey for faster and more secure login? You can use your fingerprint, face recognition, or device PIN.',
    register_passkey_button: 'Register Passkey',
    register_passkey_error: 'Failed to register passkey',
    register_passkey_success: 'Passkey registered successfully',
    register_passkey_ios_guidance:
      'iOS Device Detected: Make sure you have Face ID, Touch ID, or a device passcode set up. When prompted, complete the biometric authentication to register your passkey.',
    passkey_ios_cancelled:
      'Passkey registration was cancelled. Please try again and ensure you complete the biometric authentication.',
    passkey_ios_security_error:
      'Security error during passkey registration. Please ensure you are using HTTPS and try again.',
    passkey_ios_invalid_state:
      'Passkey already exists for this account. Please try logging in with your passkey instead.',
    passkey_ios_not_supported:
      'Passkey registration was cancelled or not supported on this device. Please ensure you have Face ID, Touch ID, or a device passcode set up.',
    change_password: 'Change Password',
    password_changed_successfully: 'Password changed successfully',
    current_password_incorrect: 'Current password is incorrect',
    new_password_required: 'All fields are required',
    new_passwords_do_not_match: 'New passwords do not match',
    new_password_min_length:
      'New password must be at least 8 characters long',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm New Password',
    not_authenticated: 'Not authenticated',
  },
  page: {
    forbidden: 'Forbidden',
  },
  message: {
    forbidden: 'You do not have permission to access this page',
  },
  configurable: {
    customize: 'Customize',
  } as TranslationMessages['ra']['configurable'],
  common: {
    loadingCosts: 'Loading costs...',
    loadingCostCategories: 'Loading cost categories...',
    failedToLoadCosts: 'Failed to load costs',
    failedToLoadCostCategories: 'Failed to load cost categories',
    loadingCategory: 'Loading category...',
    categoryNotFound: 'Category not found',
    backToCategories: 'Back to Categories',
  },
  };
